import React from 'react';
import { Users, Briefcase, ArrowRight, GlassWater, Wifi, ShieldCheck, Baby } from 'lucide-react';
import { resolveImg } from '../../context/AppContext';

const PERKS = [GlassWater, Wifi, ShieldCheck, Baby];

// Large stacked vehicle card: image on top, details, price, "select & continue" button.
const VehicleCard = ({ v, price, fixed, labels, onSelect }) => (
  <div className="rounded-3xl bg-white border border-gray-100 shadow-sm overflow-hidden" data-testid={`booking-vehicle-${v.id}`}>
    <div className="bg-[color:var(--brand-muted)]/60 px-6 pt-6 pb-2 flex items-center justify-center">
      <img src={resolveImg(v.img)} alt={v.name} className="w-full max-w-md h-44 sm:h-56 object-contain" loading="lazy" />
    </div>
    <div className="p-5 sm:p-6">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h3 className="text-2xl font-extrabold text-[color:var(--brand-dark)]">{v.name}</h3>
          <p className="text-sm text-gray-500 mt-0.5">{v.model} {labels.similar}</p>
          <div className="text-sm text-gray-500 flex items-center gap-4 mt-3">
            <span className="flex items-center gap-1.5"><Users className="w-4 h-4" /> {v.pax}</span>
            <span className="flex items-center gap-1.5"><Briefcase className="w-4 h-4" /> {v.bags}</span>
          </div>
        </div>
        <div className="text-right shrink-0">
          <div className="text-[10px] font-bold uppercase tracking-widest text-gray-400">{fixed ? labels.fixedRoute : labels.fixed}</div>
          <div className="text-2xl sm:text-3xl font-extrabold text-[color:var(--brand-dark)] whitespace-nowrap" data-testid={`booking-price-${v.id}`}>{price}</div>
        </div>
      </div>
      <ul className="mt-4 space-y-2">
        {labels.perks.map((p, i) => { const Icon = PERKS[i]; return (
          <li key={p} className="flex items-center gap-3 text-sm text-[color:var(--brand-dark)]"><Icon className="w-4 h-4" style={{ color: 'var(--brand-accent)' }} /> {p}</li>
        ); })}
      </ul>
      <button onClick={onSelect} className="accent-btn w-full rounded-2xl py-3.5 font-bold text-base flex items-center justify-center gap-2 mt-5" data-testid={`booking-select-${v.id}`}>
        {labels.select} <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  </div>
);

export default VehicleCard;
